import { environment } from "src/environments/environment";
import { RegionsEnum } from "../enums/regions-enum";
import { CountriesEnum } from "../enums/countries-enum";
import { BrandTypesEnum } from "../enums/brand-types-enum";

const EU_COUNTRY_IDS = {
  be: "BE",
  it: "IT",
  nl: "NL",
  ch: "CH",
  ie: "IE",
  lu: "LU",
  gb: "GB"
} as const;

const NA_COUNTRY_IDS = {
  ca: "CA",
  us: "US",
  uv: "UV"
} as const;



export const COUNTRIES_IDS =
  environment.region === RegionsEnum.NA ? NA_COUNTRY_IDS : EU_COUNTRY_IDS;

export type CountryId =
  | (typeof EU_COUNTRY_IDS)[keyof typeof EU_COUNTRY_IDS]
  | (typeof NA_COUNTRY_IDS)[keyof typeof NA_COUNTRY_IDS];

export const COUNTRY_TO_ID: Record<CountriesEnum, CountryId> = {
  [CountriesEnum.BE]: EU_COUNTRY_IDS.be,
  [CountriesEnum.IT]: EU_COUNTRY_IDS.it,
  [CountriesEnum.NL]: EU_COUNTRY_IDS.nl,
  [CountriesEnum.CH]: EU_COUNTRY_IDS.ch,
  [CountriesEnum.IE]: EU_COUNTRY_IDS.ie,
  [CountriesEnum.LU]: EU_COUNTRY_IDS.lu,
  [CountriesEnum.US]: NA_COUNTRY_IDS.us,
  [CountriesEnum.CA]: NA_COUNTRY_IDS.ca,
  [CountriesEnum.UV]: NA_COUNTRY_IDS.uv,
  [CountriesEnum.GB]: EU_COUNTRY_IDS.gb,
};

export const BRANDS_BY_COUNTRY: Record<CountryId, BrandTypesEnum> = {
    BE: BrandTypesEnum.LAPPERRE,
    LU: BrandTypesEnum.LAPPERRE,
    NL: BrandTypesEnum.SCHOONENBERG,
    IT: BrandTypesEnum.AUDIONOVA,
    CA: BrandTypesEnum.SILENTCLOUD,
    US: BrandTypesEnum.AUDIONOVAUS,
    CH: BrandTypesEnum.SILENTCLOUD,
    IE: BrandTypesEnum.BOOTSHEARINGCARE,
    UV: BrandTypesEnum.PHONAKGS,
    GB: BrandTypesEnum.BOOTSHEARINGCARE
  };